import React, { useCallback, useEffect } from 'react';

import EmailVerificationCodeModal from '@/modules/user/components/Verification/EmailVerificationModal/EmailVerificationCodeModal';
import useSendVerificationCodeQuery from '@/modules/user/components/Verification/queries/useSendVerificationCode.query';
import { VerificationType } from '@/modules/user/components/Verification/verification.types';
import useUpdateEmployeeQuery from '@/modules/user/queries/useUpdateEmployee.query';

interface Props {
  email: string;
  onSetVisible: (value: boolean) => void;
  onBack: () => void;
  onNext: (verificationType: VerificationType) => void;
}

const EmailVerificationModal: React.FC<Props> = ({ email, onSetVisible, onBack, onNext }) => {
  const { sendVerificationCode } = useSendVerificationCodeQuery();
  const { updateEmployee } = useUpdateEmployeeQuery();

  const handleSendVerificationCode = useCallback(async () => {
    await sendVerificationCode({
      type: VerificationType.EMAIL,
      value: email || ''
    });
  }, [email, sendVerificationCode]);

  const handleNext = useCallback(() => {
    onNext(VerificationType.EMAIL);
    updateEmployee({ is_employee_email_preferred: true});
  }, [onNext, updateEmployee]);

  useEffect(() => {
    handleSendVerificationCode();
  }, [email, handleSendVerificationCode]);
  
  return (
    <EmailVerificationCodeModal
      email={email}
      onBack={onBack}
      onSetVisible={onSetVisible}
      onNext={handleNext}
    />
  );
};

export default EmailVerificationModal;
